import * as constants from '@/common/constants';
import { getMenuData, getCurrentUserInfo } from '@/data-model';
// import Layout from '@/pages/Layout';
import routeCustomer from '@/router/modules/route-customer';
import Layout from '@/pages/Layout';
import { isEmpty, cloneDeep } from 'lodash';

export default {
    state: {
        routers: []
    },
    mutations: {
        [constants.VUEX_MUTATIONS_ROUTER_GET_ALL]: (state, newState) => {
            // newState && newState.forEach(element => {
            //     state.push(element);
            // });
            state.routers = newState;
        }
    },
    actions: {
        async [constants.VUEX_ACTIONS_ROUTER_GET_ALL] ({ commit }) {
            let menuData = await getMenuData();
            let authMenuData = [];
            let currentUserInfo = null;
            let currentUserStr = sessionStorage.getItem('currentUserInfo');
            if (isEmpty(this.currentUserStr)) {
                currentUserInfo = await getCurrentUserInfo();
                let str = JSON.stringify(currentUserInfo);
                sessionStorage.setItem('currentUserInfo', str);
                localStorage.setItem('currentUserInfo', str);
            } else {
                currentUserInfo = JSON.parse(currentUserStr);
            }
            let resources = currentUserInfo.resources;
            let menuMap = new Map();
            // menuMap.set('login', '');
            // menuMap.set('registeFirst', '');
            // menuMap.set('registeSecond', '');
            // menuMap.set('forgetPwd', '');
            // menuMap.set('process/approvalDefinitionDesign', '');// 流程定义-审批流定义
            // menuMap.set('process/processDefinitionDesign', '');// 流程定义-业务流定义
            // menuMap.set('process/processTemplateApproval', '');// 流程模板-审批流模板
            // menuMap.set('process/processTemplateProcess', '');// 流程模板-业务流模板
            // menuMap.set('process/myApprovalApply', '');// 我的审批-我申请的
            // menuMap.set('process/myApprovalApprove', '');// 我的审批-我审批的
            // menuMap.set('process/myApprovalCarbonCopy', '');// 我的审批-我参与的
            // menuMap.set('process/myProcessStartedBy', '');// 我的流程-抄送我的
            // menuMap.set('process/myProcessParticipant', '');// 我的流程-我参与的
            // menuMap.set('process/myProcessAssignee', '');// 我的流程-流程负责人
            // menuMap.set('process/myTaskAssignee', '');// 我的任务-我负责的
            // menuMap.set('process/myTaskParticipant', '');// 我的任务-我参与的

            // menuMap.set('business/businessCenter', '');// 应用中心-应用首页

            // menuMap.set('componentsDesignTitle', '');// 设计中心-组件设计
            // menuMap.set('applicationDesignTitle', '');// 设计中心-应用设计
            // menuMap.set('operationDesignTitle', '');// 设计中心-运营设计
            // menuMap.set('processDesignTitle', '');// 设计中心-流程设计
            // menuMap.set('archiveDesignTitle', '');// 设计中心-文档设计
            // menuMap.set('messageDesignTitle', '');// 设计中心-消息设计
            // menuMap.set('officeDesignTitle', '');// 设计中心-行政设计
            // menuMap.set('tenantOperationTitle', '');// 运营中心-企业运营分析

            if (resources) {
                resources.forEach(item => {
                    // console.log(item.resourceDes);
                    menuMap.set(item.resourceDes, item);
                });
            }
            // console.log(menuData, menuMap);
            menuData.forEach(menu => {
                // console.log(menu);
                // console.log(menu.name);
                // 新版右侧几个类型在设计中心中存在，也需要对比
                if (menuMap.has(menu.name) || (currentUserInfo.switchLayoutFlg === 2 && (menu.name === 'workspace' || menu.name === 'application' || menu.name === 'business' || menu.name === 'process' || menu.name === 'document' || menu.name === 'message'))) {
                // if (menuMap.has(menu.name)) {
                    let newMenu = cloneDeep(menu);
                    newMenu.children = [];
                    authMenuData.push(newMenu);
                    if (menu.children) {
                        menu.children.forEach(child => {
                            // console.log(child);
                            if (child.id.indexOf('system/resource') !== -1) {
                                if (currentUserInfo.userType === 1) {
                                    newMenu.children.push(child);
                                }
                            } else if (menuMap.has(child.id)) {
                                newMenu.children.push(child);
                            } else if ((child.id.indexOf('workspace/') !== -1)) {
                                newMenu.children.push(child);
                            }
                        });
                    }
                }
            });
            // console.log(currentUserInfo.userType);
            if (currentUserInfo.userType === 1) {
                routeCustomer[0].component = Layout;
                authMenuData = authMenuData.concat(routeCustomer);
                menuData = menuData.concat(routeCustomer);
            }
            commit(constants.VUEX_MUTATIONS_ROUTER_GET_ALL, authMenuData);// 打开权限
            // commit(constants.VUEX_MUTATIONS_ROUTER_GET_ALL, menuData);//全部权限
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/store-routers.js